import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "h-mt-20" }
const _hoisted_2 = { class: "b-edit-worker__form__row" }
const _hoisted_3 = { class: "b-edit-worker__form__avatar" }
const _hoisted_4 = { class: "b-edit-worker__form__title" }
const _hoisted_5 = { class: "b-edit-worker__form__row" }
const _hoisted_6 = { class: "b-edit-worker__form__row" }
const _hoisted_7 = { class: "b-phone-with-code fw-select-white fw-select-base__time" }
const _hoisted_8 = { class: "b-edit-worker__form__row" }
const _hoisted_9 = {
  key: 0,
  class: "h-flex h-flex-center h-flex-space-between"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwAvatarUpload = _resolveComponent("FwAvatarUpload")!
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!
  const _component_FwSelect = _resolveComponent("FwSelect")!
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "b-edit-worker__form h-flex-center h-flex-wrap",
      onKeyup: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["enter"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.editAvatarPermission)
            ? (_openBlock(), _createBlock(_component_FwAvatarUpload, {
                key: 0,
                class: "h-mv-20",
                backgroundImg: _ctx.worker.avatar_url,
                style: _normalizeStyle({
                        background: _ctx.getImage,
                        width: `70px`,
                        height: `70px`,
                        borderRadius: `50%`,
                        backgroundSize: `cover`,
                        backgroundRepeat: `no-repeat`,
                        backgroundPosition: `center`,
                    }),
                onUpload: _ctx.avatarUpload
              }, null, 8, ["backgroundImg", "style", "onUpload"]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "h-flex",
                style: _normalizeStyle({
                         width: `70px`,
                         height: `70px`,
                         background: _ctx.getImage,
                         borderRadius: `50%`,
                         backgroundImage: `url(${_ctx.worker.avatar_url})`,
                         backgroundSize: `cover`,
                         backgroundRepeat: `no-repeat`,
                         backgroundPosition: `center`,
                     })
              }, null, 4)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.workerName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_FwFormInput, {
          class: "b-base-form-margin b-edit-worker__form__input",
          fieldHasError: _ctx.validation.fieldHasError(_ctx.WORKERS_INFORMATION_LAST_NAME),
          labelType: "label-medium",
          title: `${_ctx.formTitlesMapping[_ctx.WORKERS_INFORMATION_LAST_NAME]}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwInput, {
              value: _ctx.last_name,
              type: "text",
              name: "text",
              disabled: _ctx.isDisabled,
              inputStyle: "gray",
              placeholder: "ex: Doe",
              iconRight: _ctx.iconName,
              onUpdate: _cache[0] || (_cache[0] = value => _ctx.last_name = value)
            }, null, 8, ["value", "disabled", "iconRight"])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"]),
        _createVNode(_component_FwFormInput, {
          class: "b-base-form-margin b-edit-worker__form__input h-flex h-flex-dir-column h-flex-justify-end",
          fieldHasError: _ctx.validation.fieldHasError(_ctx.WORKERS_INFORMATION_FIRST_NAME),
          style: {"display":"flex"},
          labelType: "label-medium",
          title: `${_ctx.formTitlesMapping[_ctx.WORKERS_INFORMATION_FIRST_NAME]}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwInput, {
              value: _ctx.first_name,
              type: "text",
              disabled: _ctx.isDisabled,
              name: "text",
              inputStyle: "gray",
              placeholder: "ex: John",
              iconRight: _ctx.iconName,
              onUpdate: _cache[1] || (_cache[1] = value => _ctx.first_name = value)
            }, null, 8, ["value", "disabled", "iconRight"])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FwFormInput, {
          class: "b-base-form-margin b-edit-worker__form__input",
          fieldHasError: _ctx.validation.fieldHasErrorByRule(_ctx.email, _ctx.WORKERS_INFORMATION_EMAIL, _ctx.emailRules),
          labelType: "label-medium",
          title: `${_ctx.formTitlesMapping[_ctx.WORKERS_INFORMATION_EMAIL]}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwInput, {
              value: _ctx.email,
              type: "text",
              name: "text",
              inputStyle: "gray",
              disabled: _ctx.isDisabled,
              placeholder: "ex: adress@email.com",
              iconRight: _ctx.iconName,
              error: _ctx.validation.getFieldErrorTextByRule(_ctx.email, _ctx.WORKERS_INFORMATION_EMAIL, _ctx.emailRules),
              onUpdate: _cache[2] || (_cache[2] = value => _ctx.email = value),
              onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validation.addCurrentInputToValidateArray(_ctx.WORKERS_INFORMATION_EMAIL)))
            }, null, 8, ["value", "disabled", "iconRight", "error"])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"]),
        _createVNode(_component_FwFormInput, {
          class: "b-base-form-margin b-edit-worker__form__input b-edit-worker__form__input--big",
          fieldHasError: _ctx.validation.fieldHasError(_ctx.WORKERS_INFORMATION_PHONE),
          labelType: "label-medium",
          title: _ctx.formTitlesMapping[_ctx.WORKERS_INFORMATION_PHONE]
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwInput, {
              value: _ctx.phone,
              type: "number",
              name: "text",
              inputStyle: "gray",
              disabled: _ctx.isDisabled,
              placeholder: "ex: 06 20 45 30 79",
              iconRight: _ctx.iconName,
              propsKeyDownMethod: _ctx.validation.propsKeyDownMethod,
              onUpdate: _cache[5] || (_cache[5] = value => _ctx.phone = value)
            }, {
              left: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_FwSelect, {
                    modelValue: _ctx.phoneCode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phoneCode) = $event)),
                    disabled: true,
                    noElementsFoundText: "no code",
                    options: [],
                    tryToUseSubstring: true,
                    phoneNumber: _ctx.worker.technician_profile.phone,
                    type: "phone-with-code",
                    canNotDelete: true,
                    onSubstrPhone: _ctx.substrPhone
                  }, null, 8, ["modelValue", "phoneNumber", "onSubstrPhone"])
                ])
              ]),
              _: 1
            }, 8, ["value", "disabled", "iconRight", "propsKeyDownMethod"])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_FwFormInput, {
          class: "fw-select-base b-select-colors b-base-form-margin b-edit-worker__form__input",
          labelType: "label-medium",
          title: `${_ctx.formTitlesMapping[_ctx.WORKERS_INFORMATION_COLOR]}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwSelect, {
              modelValue: _ctx.colorValue,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.colorValue) = $event)),
              propsPlaceholder: "Choose something",
              colorSelect: true,
              showRightIcon: true,
              searchable: false,
              clearable: false,
              options: _ctx.colorOptions,
              openDirection: "bottom"
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_FwFormInput, {
          class: "b-base-form-margin b-edit-worker__form__input",
          fieldHasError: _ctx.validation.fieldHasError(_ctx.WORKERS_INFORMATION_COMPANY_NAME),
          labelType: "label-medium",
          title: `${_ctx.formTitlesMapping[_ctx.WORKERS_INFORMATION_COMPANY_NAME]}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FwInput, {
              value: _ctx.company_name,
              type: "text",
              name: "text",
              disabled: true,
              inputStyle: "gray",
              iconRight: "lock",
              placeholder: "ex: Company",
              onUpdate: _cache[7] || (_cache[7] = value => _ctx.company_name = value)
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"])
      ])
    ], 32),
    (_ctx.showSubmit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_FwButton, {
            class: "h-mt-30",
            disabled: !_ctx.isFormValid || !_ctx.valid || !_ctx.inputValueCompare,
            borderRadiusType: "small-border",
            size: "medium",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('BUTTON.SAVE')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          (_ctx.isUserAuth)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: "LogOutPage" }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FwButton, {
                    class: "h-mt-20 qa-logout-button",
                    color: "alert",
                    size: "medium",
                    borderRadiusType: "small-border"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('LOG_OUT.TEXT')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}